import { useEffect, useState } from 'react';
import api from '../utils/functions/api';

// รหัส 2 ตัวอักษรของ Marketing (Document No. = <รหัส>_<ปี><เลข>) ที่เลือกได้ตอนสร้างโอกาสใหม่
// ตั้งที่ /management/document-prefixes (Information.marketing_code_prefixes) — ไม่ได้ตั้ง/โหลดไม่ได้ = MS
export const DEFAULT_MARKETING_CODES = ['MS'];

let cached = null;
let inflight = null;

export const setMarketingCodesCache = (list) => {
  cached = list;
};

const load = () => {
  if (cached) return Promise.resolve(cached);
  if (!inflight) {
    inflight = api
      .get(`${process.env.REACT_APP_API_URL}/information/`)
      .then((res) => {
        const list = res.data?.marketing_code_prefixes;
        cached = Array.isArray(list) && list.length ? list : DEFAULT_MARKETING_CODES;
        return cached;
      })
      .catch(() => DEFAULT_MARKETING_CODES)
      .finally(() => {
        inflight = null;
      });
  }
  return inflight;
};

export default function useMarketingCodePrefixes() {
  const [codes, setCodes] = useState(cached || DEFAULT_MARKETING_CODES);
  useEffect(() => {
    let alive = true;
    load().then((list) => alive && setCodes(list));
    return () => {
      alive = false;
    };
  }, []);
  return codes;
}
